var _style, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContrastIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 290.7 290.7",
    style: {
      enableBackground: "new 0 0 290.7 290.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#2B9BC6;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.4,290.7h144c40.3,0,73.4-33,73.4-73.4v-144c0-40.3-33-73.4-73.4-73.4l-144,0C33,0,0,33,0,73.4v144 C0,257.7,33,290.7,73.4,290.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M145.4,85c33.2,0.2,60.3,27.6,60,60.6c-0.3,33-27.5,59.9-60.4,59.8c-33.1-0.1-60.3-27.6-60-60.6 C85.3,111.7,112.5,84.8,145.4,85z M151.6,98.4c0,31.2,0,62.4,0,93.6c21.4-0.5,41.4-23.3,41.3-47C192.8,121.4,172.7,98.7,151.6,98.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M90.8,97.5c-2.3-1.4-4.1-2.1-5.4-3.3c-5.7-5.5-11.2-11-16.7-16.6c-3.1-3.2-3.3-6.9-0.6-9.5 c2.6-2.6,6.2-2.5,9.2,0.5c5.8,5.7,11.7,11.3,17.1,17.4c1.4,1.6,1.9,4.9,1.3,7C95.3,94.6,92.7,95.8,90.8,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M192.9,90.6c1.3-2.2,2-3.9,3.2-5.1c5.6-5.7,11.2-11.4,16.9-17c3-3,6.6-3.1,9.2-0.6c2.6,2.5,2.6,6.2-0.2,9.2 c-5.8,5.9-11.5,11.9-17.7,17.4c-1.5,1.4-4.9,1.7-7,1.1C195.6,95.1,194.5,92.5,192.9,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.9,224.8c-1.7-1.4-4.2-2.5-4.9-4.2c-0.7-1.8-0.5-5.1,0.7-6.4c5.9-6.5,12.3-12.7,18.6-18.8 c2.5-2.4,5.6-2.2,8.2,0.2c2.5,2.3,2.9,5.9,0.4,8.5c-6,6.3-12.2,12.4-18.4,18.5C75.6,223.5,73.9,223.8,71.9,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M224.8,218.4c-1.3,1.6-2.3,4.1-4.1,4.9c-1.8,0.8-5.1,0.6-6.4-0.6c-6.6-6-12.9-12.4-19.1-18.9 c-2.4-2.5-2-5.7,0.6-8.2c2.5-2.5,5.7-2.7,8.2-0.3c6.4,6.1,12.6,12.4,18.7,18.7C223.6,214.9,223.9,216.5,224.8,218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.4,57.6c0,3.9,0.1,7.7,0,11.6c-0.1,4.2-2.6,6.8-6.2,6.8c-3.7,0-6.2-2.6-6.2-6.8c-0.1-7.9-0.1-15.7,0-23.6 c0.1-4.3,2.3-6.4,6.4-6.3c3.8,0.1,5.9,2.2,6,6.3C151.5,49.5,151.4,53.6,151.4,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57.4,151.4c-3.9,0-7.7,0.1-11.6,0c-4.4-0.1-6.6-2.2-6.6-6.1c0-4.1,2.1-6.3,6.4-6.3c7.9-0.1,15.7-0.1,23.6,0 c4.2,0.1,6.7,2.6,6.7,6.3c-0.1,3.7-2.6,6-6.9,6.1C65.2,151.5,61.3,151.4,57.4,151.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M233.2,138.9c3.7,0,7.5-0.1,11.2,0c4.5,0.1,7.2,2.5,7.1,6.3c-0.1,3.6-2.7,6.1-6.9,6.1 c-7.7,0.1-15.5,0.1-23.2,0c-4.3,0-6.8-2.4-6.9-6.1c-0.1-3.8,2.6-6.3,7.1-6.3C225.4,138.9,229.3,138.9,233.2,138.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.4,233.1c0,3.9,0.1,7.7,0,11.6c-0.1,4.2-2.6,6.8-6.3,6.8c-3.6,0-6.1-2.7-6.2-6.9c-0.1-7.7-0.1-15.5,0-23.2 c0-4.3,2.4-6.9,6.1-6.9c3.9-0.1,6.3,2.5,6.4,7C151.5,225.4,151.4,229.2,151.4,233.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContrastIcon);
export default __webpack_public_path__ + "static/media/contrastIcon.dce95f786e56854615a61fcdc0dd906d.svg";
export { ForwardRef as ReactComponent };